export const LOGO_URL =
  "https://assets.cdn.filesafe.space/iZG8Wh9E8fWJxEXLqlX6/media/68282af280f93ee9c5b00177.png";
// Dr. Crystal — three portraits, used contextually.
export const FOUNDER_PORTRAIT =
  "https://customer-assets.emergentagent.com/job_service-mapper-10/artifacts/je76nk13_Image%205-6-26%20at%209.41%E2%80%AFAM.png"; // cowl-neck black dress, sage circles background — editorial
export const FOUNDER_SEATED =
  "https://customer-assets.emergentagent.com/job_service-mapper-10/artifacts/6hkp6qrt_Dr.%20Crystal%20Professional%20Photo%20copy%202.webp"; // blue blazer, seated, executive
export const FOUNDER_SPEAKING =
  "https://customer-assets.emergentagent.com/job_service-mapper-10/artifacts/g8c98xma_Screenshot%202024-06-03%20at%202.13.51%20PM.png"; // speaking with headset mic, transparent/white bg
// Default founder image used in Home hero card and small placements
export const FOUNDER_IMG = FOUNDER_SEATED;
export const HERO_BG =
  "https://images.unsplash.com/photo-1768355680597-c1650acb43cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBzY2hvb2wlMjBjYW1wdXMlMjBidWlsZGluZ3xlbnwwfHx8fDE3ODM5NzYyMTl8MA&ixlib=rb-4.1.0&q=85";
export const STUDENTS_IMG =
  "https://images.pexels.com/photos/6684506/pexels-photo-6684506.jpeg";
export const SPEAKER_IMG =
  "https://images.unsplash.com/photo-1733222814719-9c756a54ad92?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHw0fHxjb25maWRlbnQlMjBlZHVjYXRpb25hbCUyMHNwZWFrZXIlMjBzdGFnZXxlbnwwfHx8fDE3ODM5NzYyMTl8MA&ixlib=rb-4.1.0&q=85";

export const NAV_LINKS = [
  { to: "/testfit", label: "TestFit" },
  { to: "/leadership", label: "Leadership" },
  { to: "/curriculum", label: "Decision Tools" },
  { to: "/speaking", label: "Speaking" },
  { to: "/beyond-the-score", label: "Beyond the Score" },
  { to: "/about", label: "About" },
];

export const INTEREST_OPTIONS = [
  { value: "testfit_demo", label: "Schedule a TestFit Demonstration" },
  { value: "testfit_pricing", label: "Request School Pricing for TestFit" },
  { value: "speaking", label: "Invite Dr. Crystal to Speak" },
  { value: "workshop", label: "Explore a Leadership / GLAD Workshop" },
  { value: "curriculum", label: "Discuss Decision Tools & Frameworks" },
  { value: "custom_system", label: "Discuss a Custom Decision Tool" },
  { value: "podcast", label: "Beyond the Score Podcast — Guest / Interest" },
  { value: "partnership", label: "Explore a Strategic Partnership" },
  { value: "other", label: "Something Else" },
];

export const ORG_TYPES = [
  "Independent / Private School",
  "Public School District",
  "Charter Network",
  "Higher Education",
  "Association / Conference",
  "Nonprofit / Foundation",
  "Ed-Tech / Partner Organization",
  "Other",
];

export const SPEAKER_SHEET_URL =
  "https://customer-assets.emergentagent.com/job_service-mapper-10/artifacts/nfxao2o0_Dr-Crystal-Gifford-Speaker-Sheet_1.pdf";
export const EXTERNAL_REQUEST_URL = "https://drcrystalgifford.com/request";
export const GLA_ASSESSMENT_URL = "https://drcrystalgifford.com/glad";
export const BOOK_CALL_URL = "https://go.edgetechglobal.com/widget/booking/JVHrPTRbADLA9iYBjkQ2";

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
